import { createStructuredSelector } from 'reselect'

import {
  DOCUMENT_LIST,
  DOCUMENT_LIST_SUCCESS, 
  DOCUMENT_LIST_ERROR,
  DOCUMENT_PAGE_SET,
  DOCUMENT_SEARCH_SET,
  DOCUMENT_SEARCH_CHANGE,
  DOCUMENT_SEARCH_DOCUMENT_TYPE,
  DOCUMENT_SEARCH_DOCUMENT_TYPE_SUCCESS,
  DOCUMENT_SEARCH_DOCUMENT_TYPE_ERROR, 
  DOCUMENT_ADD_SET,
  DOCUMENT_ADD_MODAL_SET,
  DOCUMENT_ADD,
  DOCUMENT_ADD_SUCCESS,
  DOCUMENT_ADD_ERROR,
  DOCUMENT_ADD_CHANGE,
  DOCUMENT_DETAIL,
  DOCUMENT_DETAIL_SUCCESS,
  DOCUMENT_DETAIL_ERROR,
  DOCUMENT_VIEW_MODAL_SET,
  DOCUMENT_EDIT_CHANGE,
  DOCUMENT_EDIT_MODAL_SET,
  DOCUMENT_UPDATE,
  DOCUMENT_UPDATE_SUCCESS,
  DOCUMENT_UPDATE_ERROR,
  DOCUMENT_VIEW_TAB_SET,
  DOCUMENT_UPLOAD_SET,
  DOCUMENT_UPLOAD_SET_SUCCESS,
  DOCUMENT_UPLOAD_SET_ERROR,
  DOCUMENT_UPLOAD_RESET
} from '../../actions';

export const NAME = 'document';

export const DocumentList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type: DOCUMENT_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const DocumentListSuccess = (data) => ({
  type: DOCUMENT_LIST_SUCCESS,
  payload: data
});

export const DocumentListError = (error) => ({
  type: DOCUMENT_LIST_ERROR,
  payload: error
});

export const DocumentPageSet = (data) => ({
  type: DOCUMENT_PAGE_SET,
  payload: data
});

export const DocumentSearchSet = (data) => ({
  type: DOCUMENT_SEARCH_SET,
  payload: data
});

export const DocumentSearchChangeSet = (data) => ({
  type: DOCUMENT_SEARCH_CHANGE,
  payload: data
});

export const DocumentSearchDocumentType = (data) => ({
  type: DOCUMENT_SEARCH_DOCUMENT_TYPE,
  payload: data
});

export const DocumentSearchDocumentTypeSuccess = (message) => ({
  type: DOCUMENT_SEARCH_DOCUMENT_TYPE_SUCCESS,
  payload: message
});

export const DocumentSearchDocumentTypeError = (error) => ({
  type: DOCUMENT_SEARCH_DOCUMENT_TYPE_ERROR,
  payload: error
}); 

export const DocumentAddChangeSet = (data) => ({
  type: DOCUMENT_ADD_CHANGE,
  payload: data
});

export const DocumentAddSet = (data) => ({
  type: DOCUMENT_ADD_SET,
  payload: data
});

export const DocumentAddModalSet = (data) => ({
  type: DOCUMENT_ADD_MODAL_SET,
  payload: data
});

export const DocumentAdd = (data) => ({
  type: DOCUMENT_ADD,
  payload: data
});

export const DocumentAddSuccess = (message) => ({
  type: DOCUMENT_ADD_SUCCESS,
  payload: message
});

export const DocumentAddError = (error) => ({
  type: DOCUMENT_ADD_ERROR,
  payload: error
});

export const DocumentDetail = (data) => ({
  type: DOCUMENT_DETAIL,
  payload: data
});

export const DocumentDetailSuccess = (data) => ({
  type: DOCUMENT_DETAIL_SUCCESS,
  payload: data
});

export const DocumentDetailError = (error) => ({
  type: DOCUMENT_DETAIL_ERROR,
  payload: error
});

export const DocumentViewModalSet = (data) => ({
  type: DOCUMENT_VIEW_MODAL_SET,
  payload: data
});

export const DocumentEditModalSet = (data) => ({
  type: DOCUMENT_EDIT_MODAL_SET,
  payload: data
});

export const DocumentEditChangeSet = (data) => ({
  type: DOCUMENT_EDIT_CHANGE,
  payload: data
});

export const DocumentUpdate = (data) => ({
  type: DOCUMENT_UPDATE,
  payload: data
});

export const DocumentUpdateSuccess = (message) => ({
  type: DOCUMENT_UPDATE_SUCCESS,
  payload: message.message
});

export const DocumentUpdateError = (error) => ({
  type: DOCUMENT_UPDATE_ERROR,
  payload: error
});

export const DocumentViewTabSet = (data) => ({
  type: DOCUMENT_VIEW_TAB_SET,
  payload: data
});

export const DocumentUploadSet = (file) => ({
  type: DOCUMENT_UPLOAD_SET,
  payload: { file },
});

export const DocumentUploadSetSuccess = (items) => ({
  type: DOCUMENT_UPLOAD_SET_SUCCESS,
  payload: items,
});

export const DocumentUploadSetError = (error) => ({
  type: DOCUMENT_UPLOAD_SET_ERROR,
  payload: error,
});

export const DocumentUploadReset= () => ({
  type: DOCUMENT_UPLOAD_RESET
});

const document = (state) => state[NAME];

export const DocumentSelector = createStructuredSelector({
  document
})
 